module.exports = __webpack_public_path__ + "02_long_gold.e5724da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/02_long_gold.png
// module id = /06H
// module chunks = 0